module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/General/Smile-72c16fcea1e356ec7089e2a09a82c616.svg";